import { CdkDragDrop, transferArrayItem } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { cloneDeep } from 'lodash-es';
import { EMPTY_ARRAY_LENGTH } from '../../constants/constants';
import { IAumicoDragDropItem } from '../../interfaces/aumico-drag-drop-item.interface';

const DRAGGABLE_LIST_ID = 'draggableList';
const ORDERED_LIST_ID = 'orderedList';

@Component({
    selector: 'app-drag-drop-component',
    templateUrl: 'aumico-drag-drop.component.html',
    styleUrls: ['aumico-drag-drop.component.scss'],
})
export class AumicoDragDropComponent {
    draggableSectionsList: IAumicoDragDropItem[] = [];

    private allSections: IAumicoDragDropItem[] = [];
    @Input() set sections(value: IAumicoDragDropItem[]) {
        //ExampleInput
        //[
        //     { id: 'general', descriptionKey: 'GENERAL_KEY', fixed: true },
        //     { id: 'import', descriptionKey: 'IMPORT_KEY' },
        //     { id: 'cfs', descriptionKey: 'CASH FLOW_KEY' },
        //     { id: 'notes', descriptionKey: 'NOTES_KEY' },
        //     { id: 'aop', descriptionKey: 'AOP_KEY' },
        //     { id: 'ems', descriptionKey: 'EMS_KEY' },
        //     { id: 'adj', descriptionKey: 'ADJUSTMENTS AND RECLASSES_KEY' },
        //     { id: 'comp', descriptionKey: 'COMPL REPORTS_KEY' },
        //     { id: 'print', descriptionKey: 'PRINT_KEY', fixed: true },
        // ];
        if (value.length !== EMPTY_ARRAY_LENGTH) {
            this.allSections = cloneDeep<IAumicoDragDropItem[]>(value);
            if (this.orderedSectionsList.length === EMPTY_ARRAY_LENGTH) {
                this.setInitialDraggableSections();
                this.setFixedIndexes();
            }
        }
    }

    orderedSectionsList: (IAumicoDragDropItem | null)[] = [];
    @Input() set orderedSections(value: (IAumicoDragDropItem | null)[]) {
        if (value.length !== EMPTY_ARRAY_LENGTH && this.allSections.length !== EMPTY_ARRAY_LENGTH) {
            this.orderedSectionsList = cloneDeep<IAumicoDragDropItem[]>(value);
            this.emitOrderedSections();
            this.setRemainingDraggableSectionsFromOrderedSections();
        }
    }

    fixedIndexes: number[] = [];

    @Output() draggedOrderedSections = new EventEmitter<IAumicoDragDropItem[]>();

    private setInitialDraggableSections() {
        this.draggableSectionsList = [];
        this.allSections.forEach((section) => {
            if (!section.fixed) {
                this.draggableSectionsList.push(section);
                this.orderedSectionsList.push(null);
            } else {
                this.orderedSectionsList.push(section);
            }
        });
        this.emitOrderedSections();
    }

    private setRemainingDraggableSectionsFromOrderedSections(): void {
        this.draggableSectionsList = [];
        const orderedSectionsSet = new Set<string>(this.orderedSectionsList.map((section) => section.id));
        this.allSections.forEach((section) => {
            if (!orderedSectionsSet.has(section.id)) {
                this.draggableSectionsList.push(section);
            }
        });
    }

    private setFixedIndexes(): void {
        this.fixedIndexes = [];
        this.allSections.forEach((section) => {
            if (section.fixed) {
                const fixedIndex = this.allSections.indexOf(section);
                this.fixedIndexes.push(fixedIndex);
            }
        });
        this.fixedIndexes.pop();
    }

    drop(event: CdkDragDrop<IAumicoDragDropItem[]>): void {
        const isDraggingNotAllowed =
            event.container.id === ORDERED_LIST_ID &&
            (this.fixedIndexes.includes(event.currentIndex) || event.currentIndex >= event.container.data.length);

        if (isDraggingNotAllowed) {
            return;
        }
        // if Item is being dropped below the last item (difference between currentIndex and data length is 1), then we move it above last item(currentIndex-1)
        if (
            !isDraggingNotAllowed &&
            event.container.id === ORDERED_LIST_ID &&
            event.container.data.length - event.currentIndex === 1
        ) {
            if (event.currentIndex > 1) event.currentIndex = event.currentIndex - 1;
        }

        transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);

        if (event.previousContainer.id === ORDERED_LIST_ID) {
            this.orderedSectionsList = cloneDeep<IAumicoDragDropItem[]>(event.previousContainer.data);
            this.emitOrderedSections();
            return;
        }

        if (event.container.id === ORDERED_LIST_ID) {
            this.orderedSectionsList = cloneDeep<IAumicoDragDropItem[]>(event.container.data);
            this.emitOrderedSections();
        }
    }

    private emitOrderedSections(): void {
        const filteredSections = this.orderedSectionsList.filter((section) => section != null);
        this.draggedOrderedSections.emit(filteredSections);
    }
}
